"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = void 0;
var _react = _interopRequireWildcard(require("react"));
var _hooks = require("../../../hooks");
var _A = require("../../../UI/A");
var _PurchaseButton = require("./Partials/PurchaseButton");
var _LoginButton = require("./Partials/LoginButton");
var _Profile = require("./Partials/Profile");
var _Notifications = require("./Partials/Notifications");
var _LangSelection = require("./Partials/LangSelection");
var _Header = require("./Header.labels");
var _Header2 = _interopRequireDefault(require("./Header.styles"));
var _LogoOfekHE = _interopRequireDefault(require("./resources/LogoOfekHE.svg"));
var _LogoOfekAR = _interopRequireDefault(require("./resources/LogoOfekAR.svg"));
var _LogoOfekEN = _interopRequireDefault(require("./resources/LogoOfekEN.svg"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Header = function Header(props) {
  var logoUrl = props.logoUrl,
    logoLink = props.logoLink,
    avatarUrl = props.avatarUrl,
    avatarSize = props.avatarSize,
    isShowLogin = props.isShowLogin,
    isShowNotifications = props.isShowNotifications,
    lang = props.lang,
    langs = props.langs,
    notifications = props.notifications,
    children = props.children,
    purchaseButtonGuestLabel = props.purchaseButtonGuestLabel,
    purchaseButtonGuestHref = props.purchaseButtonGuestHref,
    purchaseButtonLabel = props.purchaseButtonLabel,
    purchaseButtonHref = props.purchaseButtonHref,
    supportButtonLabel = props.supportButtonLabel,
    _props$supportButtonH = props.supportButtonHref,
    supportButtonHref = _props$supportButtonH === void 0 ? '' : _props$supportButtonH,
    onLanguageChange = props.onLanguageChange,
    onShowProfileClick = props.onShowProfileClick,
    headerAttributes = props.headerAttributes;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var user = (0, _hooks.useSessionData)();
  var getLabel = (0, _hooks.useLabels)({
    labels: _Header.labels
  });
  var styles = (0, _Header2.default)(isMobileView, !Boolean(user === null || user === void 0 ? void 0 : user.userId));
  var siteLogo = (0, _react.useMemo)(function () {
    return {
      he: _LogoOfekHE.default,
      ar: _LogoOfekAR.default,
      en: _LogoOfekEN.default
    };
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("header", _objectSpread(_objectSpread({
    className: styles['cc-Header']
  }, headerAttributes), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: styles['cc-Header__logo'],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_A.A, {
        to: logoLink ? logoLink : "/".concat(lang),
        target: "_top",
        customStyle: styles['cc-Header__logo__link'],
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: logoUrl !== null && logoUrl !== void 0 ? logoUrl : siteLogo[lang],
          alt: getLabel('cet')
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-Header__toolbar'],
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_PurchaseButton.PurchaseButton, {
        isMobileView: isMobileView,
        user: user,
        purchaseButtonGuestLabel: purchaseButtonGuestLabel,
        purchaseButtonGuestHref: purchaseButtonGuestHref,
        purchaseButtonLabel: purchaseButtonLabel,
        purchaseButtonHref: purchaseButtonHref
      }), !isMobileView && supportButtonLabel && supportButtonHref && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_A.A, {
          to: supportButtonHref,
          target: "_blank",
          color: "primary",
          category: "upperToolbar",
          label: "support",
          shape: "roundedRectangle",
          view: "outlined",
          isBtnView: true,
          ariaLabel: supportButtonLabel,
          children: supportButtonLabel
        })
      }), !isMobileView && (children || isShowNotifications || !(user !== null && user !== void 0 && user.userId)) && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: styles['cc-Header__toolbar__spacer']
      }), children, isShowNotifications && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Notifications.Notifications, {
        isMobileView: isMobileView,
        user: user,
        notifications: notifications
      }), !isMobileView && (user === null || user === void 0 ? void 0 : user.userId) && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: styles['cc-Header__toolbar__spacer']
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Profile.Profile, {
        isMobileView: isMobileView,
        lang: lang,
        avatarUrl: avatarUrl,
        avatarSize: avatarSize,
        user: user,
        onShowProfileClick: onShowProfileClick
      }), isShowLogin && /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoginButton.LoginButton, {
        isMobileView: isMobileView,
        user: user
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_LangSelection.LangSelection, {
        isMobileView: isMobileView,
        user: user,
        lang: lang,
        langs: langs,
        onLanguageChange: onLanguageChange
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-Header__TopMarker'],
      "data-scrolling-handler-element": "headerTopMarker"
    })]
  }));
};
exports.Header = Header;